import { Component, OnInit, HostListener } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CommonHttpService } from "../commonHttp.service";
import { LoaderService } from "../../_shared/services/loader.service";
import { AddToCartService } from "../../_shared/services/add-to-cart.service";

@Component({
  selector: "app-top-selling-products",
  templateUrl: "./top-selling-products.component.html",
  styleUrls: ["./top-selling-products.component.css"],
})
export class TopSellingProductsComponent implements OnInit {
  paramsId: number;
  relevance: any = 0;
  baseUrl: any = environment.apiUrl;
  imageUrl: any = environment.imageUrl;
  products: any = [];
  allProducts: any = [];
  brands: any = [];
  sendData: any = {};
  isListEnd: boolean = false;
  offset: number = 0;
  offsetLoader: boolean = false;
  offsetResFetched: boolean = true;
  brandIds: any = [];
  sortType: any = "PriceHigh";
  cart: any = {};
  cartItems: any = [];
  availableQuantity: number;
  quantityError: boolean = false;
  showLoaderProduct: boolean = false;

  constructor(
    private service: CommonHttpService,
    private addToCartService: AddToCartService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) {
    this.addToCartService.isCartChanged.subscribe((flag) => {
      this.cart = JSON.parse(localStorage.getItem("cart"));
      this.cartItems = this.cart != null ? this.cart.EcartItem : [];
      this.updateCart();
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.cart = JSON.parse(localStorage.getItem("cart"));
    this.cartItems = this.cart != null ? this.cart.EcartItem : [];

    setTimeout(() => {
      this.loadData(1);
    }, 1);
  }

  loadData(flag) {
    this.offsetLoader = false;
    flag == 1 ? (this.showLoaderProduct = true) : (this.offsetLoader = true);
    this.sendData = { Limit: 12, Offset: this.offset };

    this.service
      .create(this.baseUrl + "ProductAPI/GetTopSellingProducts", this.sendData)
      .subscribe(
        (data) => {
          console.log(data);
          this.offsetResFetched = true;
          this.offsetLoader = false;
          this.offset = this.offset + 12;
          this.products = data;
          for (var i = 0; i < this.products.length; i++) {
            this.allProducts.push(this.products[i]);
          }
          if (this.products.length == 0) {
            this.isListEnd = true;
          }
          this.updateCart();
          this.showLoaderProduct = false;
        },
        (error) => {
          this.showLoaderProduct = false;
        }
      );
  }

  sort_order = function () {
    console.log(this.relevance);
    this.getfilterProducts();
  };
  getfilterProducts() {
    this.showLoaderProduct = true;
    let postData = {
      Limit: 12,
      Offset: 0,
    };

    this.service
      .create(
        this.baseUrl +
        "ProductAPI/GetTopSellingProducts?SortBy=" +
        this.relevance,
        postData
      )
      .subscribe((data) => {
        console.log("all products");
        console.log(data);
        this.allProducts = data;

        console.log(this.allProducts);

        this.showLoaderProduct = false;
      });
  }

  addToCart(product) {
    product.cartQuantity = 1;
    this.addToCartService.addToCart(product);
  }

  updateCart() {
    for (var i = 0; i < this.allProducts.length; i++) {
      this.allProducts[i].isAddedToCart = false;
    }
    for (var i = 0; i < this.cartItems.length; i++) {
      for (var j = 0; j < this.allProducts.length; j++) {
        if (this.cartItems[i].ProductId == this.allProducts[j].productId) {
          this.allProducts[j].isAddedToCart = true;
          this.allProducts[j].cartQuantity = this.cartItems[i].Quantity;
        }
      }
    }
  }

  substractquantity(cartQuantity, i) {
    this.quantityError = false;
    this.allProducts[i].cartQuantity = cartQuantity - 1;
    this.addToCartService.addToCart(this.allProducts[i]);
  }

  addQuantity(cartQuantity, i) {
    if (cartQuantity + 1 > this.allProducts[i].totalStock) {
      this.quantityError = true;
      this.availableQuantity = this.allProducts[i].totalStock;
      this.allProducts[i].cartQuantity = cartQuantity;
    } else {
      this.quantityError = false;
      this.allProducts[i].cartQuantity = cartQuantity + 1;
    }
    this.addToCartService.addToCart(this.allProducts[i]);
  }

  onQuantityChange(cartQuantity, i) {
    if (cartQuantity > this.allProducts[i].totalStock) {
      this.quantityError = true;
      this.availableQuantity = this.allProducts[i].totalStock;
      this.allProducts[i].cartQuantity = this.allProducts[i].totalStock;
    } else {
      this.quantityError = false;
      this.allProducts[i].cartQuantity = cartQuantity;
    }
    this.addToCartService.addToCart(this.allProducts[i]);
  }

  @HostListener("window:scroll", [])
  onScroll(): void {
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 500 &&
      this.allProducts.length > 0
    ) {
      if (!this.isListEnd && this.offsetResFetched) {
        console.log("a");
        this.offsetResFetched = false;
        this.loadData(2);
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/top-selling-products/top-selling-products.component.ts